import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToEmployeeFilesListPage = () => {
  const { navigation } = useNavigation()

  const to = navigation.files.employeeFiles.list.fullPath()

  return <Navigate replace to={to} />
}

export default RedirectToEmployeeFilesListPage
